export default {
  course_title: '02Web-智門戶課程',
  course_title_list: "0201Web-顯示課程列表",
  course_watch_course: "0202Web-查看課程",
  course_category: '課程分類',
  course_new: '按最新',
  course_hot: '按最熱'
}
